const seoFlagEncoded = "&lt;!--friendly--&gt;";
const seoFlagDecoded = "<!--friendly-->";

export const isSeoFriendly = (headerHTML, isEncoded) =>
  headerHTML.startsWith(isEncoded ? seoFlagEncoded : seoFlagDecoded);

export const removeSeoFlagDecoded = str => {
  const newString = str.replace(seoFlagDecoded, "");

  return newString.trim();
};
